export default __webpack_public_path__ + "static/media/01.a5d06086.jpg";